/**
 * Derives the anchor id for a legal-document heading from its rendered text.
 *
 * The table of contents in `LegalDocumentPage` scrolls to these ids, so the
 * page's `sections` list and the markdown headings must agree — see
 * `__tests__/legalDocumentSections.test.ts`.
 */
export function slugifyHeading(text: string): string {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}
